import { useMemo } from 'react';
import { convertSlugToConversationId } from 'src/utils';
import { useQueryParams } from 'src/hooks';

export const useComparingConversationsParams = () => {
  const { searchParams } = useQueryParams();

  const {
    first_comparing_conv,
    second_comparing_conv,
    compare: isCompareMode,
  } = searchParams;
  const firstComparedConvId = convertSlugToConversationId(first_comparing_conv);
  const secondComparedConvId = convertSlugToConversationId(
    second_comparing_conv,
  );

  return useMemo(
    () => ({
      firstComparedConvId,
      secondComparedConvId,
      isCompareMode: !!isCompareMode,
    }),
    [firstComparedConvId, secondComparedConvId, isCompareMode],
  );
};
